export default __webpack_public_path__ + "static/shoppers-at-jb-83c5349a8abbb112eba22f793e01ecc8.jpg";